import { gql } from "@apollo/client";
import { BaseTerminalInfo } from "./getTerminalsCall";

export const GET_TERMINAL_TYPES = gql`
  query TerminalTypes {
    terminal {
      types {
        terminal_type_id
        input
        val1_type
        val1_min
        val1_max
        val2_type
        val2_min
        val2_max
        extra
        time_act
        programmed
        limit_value
      }
    }
  }
`

export interface TerminalTypesInfo extends WithIdentifier<BaseTerminalInfo, "terminal_type_id"> {
  __typename?: string;
  input: number;
}

export interface TerminalTypesResponse {
  terminal: {
    types: TerminalTypesInfo[]
  }
}